import type { ContentBlocksProps } from '../constants/content-pages'

export function ContentBlocks({ blocks }: ContentBlocksProps) {
  return (
    <>
      {blocks.map((block, index) => {
        if (block.kind === 'list') {
          return (
            <ul key={`list-${index}`} className="content-page__list">
              {block.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )
        }

        if (block.kind === 'note') {
          return (
            <p key={`note-${index}`} className="content-page__note">
              {block.text}
            </p>
          )
        }

        return <p key={`p-${index}`}>{block.text}</p>
      })}
    </>
  )
}
